import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingScreen = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-white">
    <div className="text-center">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} className="text-primary" />} />
      <h2 className="mt-4 text-xl font-medium text-gray-700">Loading Unzippd...</h2>
    </div>
  </div>
);

export default LoadingScreen;